// import RepositoryFactory from "@/apis";
// const hoc = RepositoryFactory.hoc;
import medicalFaq from "../../apis/medicalFaq";

export default {
  createMedicalFaq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await medicalFaq.createMedicalFaq(payload);
        // console.log(data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getMedicalFaq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalFaq.getMedicalFaq(payload);
        commit("SET_MEDICAL_FAQ", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getFilteredMedicalFaq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalFaq.getMedicalFaq(payload);
        commit("SET_FILTERED_MEDICAL_FAQ", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateMedicalFaq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalFaq.updateMedicalFaq(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteMedicalFaq({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await medicalFaq.deleteMedicalFaq(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
